import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d416df2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hotel-link" }
const _hoisted_2 = { class: "hotel-link-content" }
const _hoisted_3 = { class: "hotel-image-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "lodging-details" }
const _hoisted_6 = { class: "expander-content" }
const _hoisted_7 = { class: "lodging-detail" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lodging-details-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined lodging-details-icon" }, "attach_money")
], -1))
const _hoisted_9 = { class: "lodging-details-text" }
const _hoisted_10 = { class: "lodging-detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lodging-details-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined lodging-details-icon" }, "directions_car")
], -1))
const _hoisted_12 = { class: "lodging-details-text" }
const _hoisted_13 = { class: "lodging-detail" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lodging-details-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined lodging-details-icon" }, "distance")
], -1))
const _hoisted_15 = { class: "lodging-details-text" }
const _hoisted_16 = { class: "lodging-detail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lodging-details-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, "event")
], -1))
const _hoisted_18 = { class: "lodging-details-text" }
const _hoisted_19 = { class: "hotel-buttons" }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button-on-purple" }, " Map ", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button-on-purple" }, "Book Online", -1))
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.hotel.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require(`@/assets/${_ctx.imageName}`),
          width: "300"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.hotel.description), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, "$" + _toDisplayString(_ctx.hotel.basePrice) + " / night ($" + _toDisplayString(_ctx.hotel.basePrice + _ctx.hotel.taxesAndFees) + " with taxes & fees)", 1)
        ]),
        _createElementVNode("li", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.hotel.parkingPolicy), 1)
        ]),
        _createElementVNode("li", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.hotel.distanceToWeddingVenue.toString()) + " miles from venue", 1)
        ]),
        _createElementVNode("li", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("p", _hoisted_18, "Book by " + _toDisplayString(_ctx.hotel.bookByDate), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("a", {
        href: _ctx.googleMapsUrl,
        target: "_blank"
      }, _hoisted_22, 8, _hoisted_20),
      _createElementVNode("a", {
        href: _ctx.bookingUrl,
        target: "_blank"
      }, _hoisted_25, 8, _hoisted_23)
    ])
  ]))
}